<div>
  <div class="column-100" *ngIf="data.finalSolutionDate">
    <label>Datum</label>
    <div class="cb">{{ data.finalSolutionDate | date: 'd. M. yyyy' }}</div>
  </div>
  <div class="column-100 mt-5">
    <label>Schvalovatel</label>
    <div class="cb">{{ data.finalSolutionApprover | username}}</div>
  </div>
  <div class="column-100 mt-5" *ngIf="data.finalSolutionState === FinalSolutionStateEnum.REJECTED && data.finalSolutionNote">
    <label>Důvod zamítnutí</label>
    <div class="cb">{{ data.finalSolutionNote }}</div>
  </div>
</div>
